// Author Eric
// Date 2021-06-07 16:53:40

import * as model from "@/model/sithMes/andon/SithMesAndonTaskModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesAndonTask(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_ANDON_URL,
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'dispatchVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'executeVo'
    })
    .buildStore()
